import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-reload",
  "use": "icon-reload-usage",
  "viewBox": "0 0 27.675 28",
  "content": "<symbol fill=\"currentColor\" class=\"\" viewBox=\"0 0 27.675 28\" id=\"icon-reload\">\n  <path id=\"icon-reload_2b6b57670e41d323fa139ea17e852fd3-comm_icon_retry\" d=\"M0,18.972l9.548-.161L7.155,22.229a10.746,10.746,0,1,0-4.056-8.4c0,.306.013.617.04.921H.057c-.021-.3-.03-.612-.03-.921A13.827,13.827,0,0,1,26.586,8.443a13.824,13.824,0,0,1-21.2,16.313L3.113,28Z\" />\n\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol